import { observable } from 'mobx'
import { sortBy } from '../../../../utils/helpers'

class MagicQuadrant {
    constructor(store) {
        this.store = store
    }

    @observable clientOptions = []

    @observable request= {
        clientId: '',
        file: null,
    }

    socket= null

    getClients = async () => {
        const { store } = this
        const { clientId: id } = store.userData
        let clients = []
        if (id === 1) {
            const response = await store.http.get('/client')
            clients = response.clients
        } else {
            const response = await store.http.get(`/client/${id}`)
            clients = [{
                id,
                name: response.name,
            }]
        }

        this.clientOptions = sortBy(clients, 'name')
            .map(({ clientId, name }) => ({
                value: clientId,
                label: `[${clientId}] - ${name}`,
            }))
    }

    handleChange = async (e, element) => {
        if (element === 'file') {
            this.request.file = e.target.files[0]
        } else {
            this.request.clientId = e.value
        }
    }

    validate = () => {
        if (!this.request.clientId) {
            throw new Error('Select a Client')
        }
        if (!this.request.file) {
            throw new Error('Insert a File')
        }
    }

    fileUpload = async () => {
        const httpUrl = this.store.http.gatewayUrl
        const socketUrl = httpUrl.replace(/https:\/\//, 'wss://').replace(/http:\/\//, 'ws://')
        let query = 'target=import'
        query += '&method=magicQuadrantImport'
        query += `&token=${this.store.token}`
        this.socket = io(socketUrl, {
            query,
        })

        this.socket.on('connection', () => {
            this.socket.emit('data', this.request.file)
        })

        this.socket.on('response', (response) => {
            try {
                if (response.split(' ')[0] === 'Success') {
                    this.store.addNotification({ body: response, level: 'success' })
                    this.socket.disconnect()
                } else {
                    const parsedResponse = JSON.parse(response)
                    this.socket.emit('data', JSON.stringify(
                        {
                            kind: 'magicQuadrantImport',
                            userId: this.store.tokenData.userId,
                            clientId: this.request.clientId,
                            fileName: parsedResponse.fileName,

                        },

                    ))
                }
            } catch (error) {
                this.store.handleError({ body: response, level: 'error' })
                this.socket.disconnect()
            }
        })

        this.socket.onerror = () => {
            this.socket.disconnect()
        }
    }

    submitMagicQuadrant = async () => {
        try {
            this.validate()
            this.fileUpload()
        } catch (e) {
            this.store.handleError({ body: `something went wrong: ${e.message}`, level: 'error' })
        }
    }
}
export default MagicQuadrant
